import { DateTime, Settings } from 'luxon'
Settings.defaultZoneName = 'Europe/Moscow'
Settings.defaultLocale = 'ru';
export { DateTime }
